module.exports = __webpack_public_path__ + "img/Des_Keane.4b982e95.jpg";